import { render } from "./app-dashboard.html?vue&type=template&id=41ab275c&scoped=true&ts=true&external"
import script from "./app-dashboard.ts?vue&type=script&lang=ts&external"
export * from "./app-dashboard.ts?vue&type=script&lang=ts&external"

import "./app-dashboard.scss?vue&type=style&index=0&id=41ab275c&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ab275c"]])

export default __exports__